import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { TranslationService } from '../../import/services/translation.service';
import { DataAdministrationService } from '../../data-administration/services/data-administration-service';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent implements OnInit {
  @Input() prefix: string;
  @Input() subroute: string; 
  @Input() entity: Object = {};
  @Input() entityType: string;
  entityType_single_translated: string;
  selectedUserId: string;
  loading: boolean = true;
  referencedEntities: Object = {};
  referencedEntityKeys = [];

  constructor(private dataAdministrationService: DataAdministrationService, public activeModal: NgbActiveModal, private translate: TranslateService, private translationService: TranslationService, private toastManager: ToastrService, private router: Router) { }

  ngOnInit() {
	this.translate.get('data_administration.entities.' + this.entityType + ".single").subscribe((res: string) => { this.entityType_single_translated = res; });
	this.dataAdministrationService.getReferencedEntities(this.entity['id'], this.entityType).subscribe(referencedEntities => {
		this.referencedEntities = referencedEntities;
		this.referencedEntityKeys = Object.keys(referencedEntities);
		this.loading = false;
	});
  }

  cancel() {
	this.activeModal.close();
  }

  deleteEntity() {
	this.dataAdministrationService.deleteEntity(this.prefix, this.subroute, this.entity).subscribe(
		response => {
			this.translate.get('data_administration.success.delete', {entityType: this.entityType_single_translated})
			.subscribe((res: string) => {
				this.toastManager.success(res);
				this.activeModal.close();
				this.router.navigate(['data-administration/' + this.subroute]);
			});
		}, err => {
			this.translate.get('data_administration.errors.delete',  {entityType: this.entityType_single_translated})
			.subscribe((res: string) => { this.toastManager.error(res); }); 
		}
	)
}

}
